import { Component } from '@angular/core';

@Component({
  selector: 'cat-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/components/footer/footer.component.ts